export default __webpack_public_path__ + "static/media/info_01.5c9a3a89.png";